var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reo-plan-message"},[_c('table',{attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tbody',_vm._l((_vm.list),function(item,index){return _c('tr',{key:index},[_c('td',{staticClass:"label"},[_vm._v(_vm._s(item.label)+":")]),_vm._v(" "),_c('td',{class:{
                    red: item.red
                }},_vm._l((item.texts),function(text,i){return _c('p',{key:i},[_vm._v("\n                        "+_vm._s(text)+"\n                    ")])}))])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e0b3698","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/planMessage.vue
// module id = null
// module chunks = 